import React, { useContext, useEffect, useRef, useState } from 'react'
import { WrapMarkWordsContent, DrawerStyles, WrapMarkWords, WrapScreenMarkWords, WordsContentStyles } from './Style'
import { useLocation } from 'react-router-dom'
import { Header, ErrorTypes, wordHooks } from 'pages/Words'
import { Stepper } from 'components/School/MakingRecordAssessments'
import { IconButton, useMediaQuery } from '@mui/material'
import { CacheProvider } from '@emotion/react'
import { cacheLtr } from 'styles/theme'
import { Close } from '@mui/icons-material'
import { AnimatePresence } from "motion/react"
import * as motion from "motion/react-client"

const WordsContent = (props) => {
    const { categoryItem: category, wordListPage } = useContext(WordsContext)
    const { overflow, questions, contentToPrint, disabled, student, isSystem, type, words, settings, comment } = props

    const { state = {} } = useLocation();

    const studentView = student || state?.student

    let Component = category.component
    if (studentView)
        Component = category.student?.component
    else if (isSystem)
        Component = category.system?.component

    let transition = student ? 9 : 0.7
    if (!category.animation)
        transition = 0.7

    return (
        <WordsContentStyles
            fullHeight={studentView && category?.student?.fullHeight}
            overflow={overflow}
            student={student}
            ref={contentToPrint}
            page={Math.abs(wordListPage)}
        >
            <WrapMarkWordsContent student={student} $disabled={disabled}>
                <div align="center" className='words-content'>
                    <AnimatePresence mode="wait">
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: transition }}
                            className='words-animation'
                        >
                            <Component questions={questions} visibleType={type} words={words} settings={settings} comment={comment} />
                        </motion.div>
                    </AnimatePresence>
                    <Stepper />
                </div>
            </WrapMarkWordsContent>
        </WordsContentStyles>
    )
}

const Words = (props) => {
    const { showBlurred, isDemo, wordsPerLine, wordAction, title, overflow, questionValues, setQuestionValues, questions, hideNextButton, hideDisabledNext = false, changeBoldWordAfterSeconds, boldWordAfterSeconds, hideHeader, initialPage, handleNext, finishPerfom, showErrorTypes, showCartoon, words, type, settings, disabled, student, comment } = props
    const [open, setOpen] = useState(false);
    const [wordListPage, setWordListPage] = useState(0);
    const [wordListIndex, setWordListIndex] = useState(0);
    const { state = {} } = useLocation();
    const contentToPrint = useRef(null);

    const assessmentCategory = wordHooks.useAssessmentCategory()
    let categoryItem = assessmentCategory[type || "DEFAULT"]

    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('md'), { noSsr: true })

    const { header = props.header, footer = props.footer } = state || {}

    const commonState = {
        words,
        questions,
        title,
        hideDisabledNext,
        isDemo,
        settings,
        wordListPage, setWordListPage,
        wordListIndex, setWordListIndex,
        finishPerfom,
        showBlurred,
        showCartoon,
        wordAction,
        categoryItem,
        handleNext,
        initialPage,
        hideNextButton,
        wordsPerLine,
        questionValues, setQuestionValues,
        boldWordAfterSeconds, changeBoldWordAfterSeconds
    }

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setOpen(open);
    };


    return (
        <WordsContext.Provider value={commonState}>
            <WrapScreenMarkWords overflow={overflow} className='WrapScreenMarkWords' student={student}>
                {student || hideHeader || <Header {...props} toggleDrawer={toggleDrawer} contentToPrint={contentToPrint} />}
                {/* {components?.[header] && components?.[header]} */}
                {showErrorTypes && <ErrorTypes />}
                {isSmallScreen &&
                    <CacheProvider value={cacheLtr}>
                        <DrawerStyles anchor='right' open={open} onClose={toggleDrawer(false)}>
                            <div className='close-drawer'>
                                <IconButton onClick={toggleDrawer(false)}>
                                    <Close />
                                </IconButton>
                            </div>
                            <WordsContent {...props} contentToPrint={contentToPrint} />
                        </DrawerStyles>
                    </CacheProvider>
                }
                {!isSmallScreen && <WordsContent {...props} contentToPrint={contentToPrint} />}
            </WrapScreenMarkWords>
        </WordsContext.Provider>
    )
}

export const WordsContext = React.createContext()
export default Words